var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.0007 12.4997V14.9997H5.00065V12.4997H3.33398V14.9997C3.33398 15.9163 4.08398 16.6663 5.00065 16.6663H15.0007C15.9173 16.6663 16.6673 15.9163 16.6673 14.9997V12.4997H15.0007ZM5.83398 7.49967L7.00898 8.67467L9.16732 6.52467V13.333H10.834V6.52467L12.9923 8.67467L14.1673 7.49967L10.0007 3.33301L5.83398 7.49967Z",
    fill: "#4D7EFC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload);
export default __webpack_public_path__ + "static/media/upload.3282977c55685890686a58fe4f9e8251.svg";
export { ForwardRef as ReactComponent };